module.exports = require("./tabs/index.js");
